<template>
  <v-container class="mt-3">
    <v-row>
      <v-col cols="12" class="mt-0 pt-0 d-flex">
        <v-spacer />
        <v-btn
          color="secondary"
          class="text-none ml-3"
          small
          @click="handlePrintTranscript"
          ><v-icon x-small>mdi-printer</v-icon>Print E Transcript</v-btn
        >
      </v-col>
    </v-row>
    <template v-for="enrollmentTerm in sortedEnrollmentTerms">
      <v-row class="grey lighten-3 py-2" :key="enrollmentTerm.uuid + '1'">
        <v-col cols="12" class="my-0 py-0">
          <span class="mb-0 mr-1 ml-4 primary--text font-weight-medium">
            Term:
          </span>
          <span class="mb-0 black--text">
            {{ enrollmentTerm.academic_term.academic_term }}
          </span>
        </v-col>
      </v-row>
      <v-simple-table
        dense
        class="mt-5 mb-10 simple-table"
        :key="enrollmentTerm.uuid + '2'"
      >
        <thead>
          <tr>
            <th class="primary--text" width="300">
              <span class="primary--text">Subject</span>
            </th>
            <th class="primary--text" width="300">
              <span class="primary--text">Grade Title</span>
            </th>
            <th class="primary--text">
              <span class="primary--text">Score</span>
            </th>
            <th class="primary--text">
              <span class="primary--text">Grade</span>
            </th>
            <th class="primary--text" width="300">
              <span class="primary--text">Comment</span>
            </th>
            <th class="primary--text" width="300">
              <span class="primary--text">Is Final</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="enrollmentDetail in enrollmentTerm.enrollment_details"
          >
            <template v-for="gradeDetail in getGrades(enrollmentDetail)">
              <tr
                :key="gradeDetail.uuid"
                v-if="gradeDetail && gradeDetail.is_visible"
              >
                <td>
                  {{ getSubjectText(enrollmentDetail) }}
                </td>
                <td>
                  {{ getGradeType(gradeDetail) }}
                  -
                  {{ gradeDetail.grade_header.grade_title }}
                </td>
                <td>{{ gradeDetail.grade_score }}</td>
                <td>
                  <span
                    :class="`${
                      gradeDetail.grade_header.is_final == 2
                        ? 'font-weight-bold primary--text'
                        : ''
                    }`"
                  >
                    {{ gradeDetail.grade.grade }}
                  </span>
                </td>
                <td>{{ gradeDetail.comment }}</td>
                <td>
                  {{ gradeDetail.is_out_of_statistics == 1 ? "Yes" : "" }}
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </v-simple-table>
    </template>
  </v-container>
</template>

<script>
export default {
  props: ["enrollmentTerms", "handlePrintTranscript"],
  computed: {
    configurations() {
      return this.$store.getters["common/configurations"];
    },
    sortedEnrollmentTerms() {
      const enrollmentTerms = this.enrollmentTerms
        ? JSON.parse(JSON.stringify(this.enrollmentTerms))
        : [];
      return enrollmentTerms.sort((a, b) =>
        a.academic_term.academic_term > b.academic_term.academic_term ? 1 : -1
      );
    },
  },
  methods: {
    getSubjectText(enrollmentDetail) {
      return enrollmentDetail.program_term_detail &&
        enrollmentDetail.program_term_detail.subject
        ? `${enrollmentDetail.program_term_detail.subject.subject_code} ${enrollmentDetail.program_term_detail.subject.subject_desc}`
        : "";
    },
    getGrades(enrollmentDetail) {
      return enrollmentDetail.grade_details.sort((a, b) =>
        a.grade_score < b.grade_score ? 1 : -1
      );
    },
    getGradeType(gradeDetail) {
      return gradeDetail?.grade_header?.grade_type?.grade_type_desc;
    },
  },
};
</script>

<style></style>
